/**
 * Admin navigation
 */
class AdminNav {
  constructor() {
    this.adminNavTrigger = document.querySelectorAll(".rx-admin-nav-trigger");
    this.leftNavbarToggleClasses = [
      "layout-left-navbar--minimize",
      "layout-left-navbar--show",
    ];
    this.defaultNavClass = "layout-left-navbar--show";
    this.navbar = document.querySelector(".rx-admin-nav");
    this.navItems = document.querySelectorAll(".rx-admin-nav li");
    this.linkHasSubMenu = [];
    this.root = document.querySelector(":root");

    this.addFirstLetterDynamic = false;
  }

  initialProcess() {
    // Check for submenu and add class into the list item
    this.navItems.forEach((item) => {
      if (item.querySelector("ul")) {
        // item.classList.add("has-sub");
        // Push the link in the array which contains the submenu
        this.linkHasSubMenu.push(item.querySelector("a"));
      }
    });

    // Attach Event Listener to the link
    let collapseID = 0;
    this.linkHasSubMenu.forEach((link) => {
      link.addEventListener("click", (event) => {
        // event.preventDefault();

        // Toggle active class
        event.target.closest("li").classList.toggle("active");
      });

      // Add link collapse attributes
      link.setAttribute("data-bs-toggle", "collapse");
      link.setAttribute("href", `#linkCollapse${collapseID}`);
      link.setAttribute("aria-controls", `linkCollapse${collapseID}`);
      link.setAttribute("aria-expanded", "false");

      // Add collapse attributes into target list
      let ul = link.closest("li").querySelector("ul");
      ul.classList.add("collapse");
      ul.setAttribute("id", `linkCollapse${collapseID}`);

      collapseID++;
    });

    var collapseElementList2 = [].slice.call(this.linkHasSubMenu);
    var collapseList2 = collapseElementList2.map(function (collapseEl) {
      return new bootstrap.Collapse(collapseEl);
    });

    // Add first latter element into sub menu navigation
    if (this.addFirstLetterDynamic) {
      let submenuLinks = this.navbar.querySelectorAll("ul ul a");
      submenuLinks.forEach((link) => {
        let newFirstLetterElement = document.createElement("span");
        newFirstLetterElement.className = "first-letter";
        newFirstLetterElement.innerHTML = link.innerText.trim("").slice(0, 1);

        link.insertAdjacentElement("afterbegin", newFirstLetterElement);
      });
    }
  }

  navTrigger() {
    // Add default class
    document.body.classList.add(this.defaultNavClass);

    new ToggleClasses({
      toggleClassesArray: this.leftNavbarToggleClasses,
      defaultClass: this.defaultNavClass,
      toggleClassTrigger: this.adminNavTrigger,
    }).init();

    // Remove hover mode if switch to minimize mode
    this.adminNavTrigger.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (document.body.classList.contains("layout-left-navbar--hover")) {
          this.showNavPanel();
        }
      });
    });
  }

  // Getting a CSS variable value
  getCssVariable(variable) {
    let rootStyle = getComputedStyle(this.root);
    return rootStyle.getPropertyValue(variable);
  }

  showNavPanel() {
    let defaultLeftNavbarWidth = this.getCssVariable(
      "--rx-layout-left-navbar-default-width"
    );

    let leftNavbar = document.querySelector(".layout-left-navbar");

    leftNavbar.classList.remove("js-disable-observe-width");

    this.root.style.setProperty(
      "--rx-layout-left-navbar-width",
      defaultLeftNavbarWidth
    );

    document.body.classList.remove("layout-left-navbar--hover");

    leftNavbar.classList.remove("active-hover-mode");
  }

  hoverNavPanel() {
    let leftNavbar = document.querySelector(".layout-left-navbar");

    leftNavbar.classList.add("js-disable-observe-width");

    this.root.style.setProperty("--rx-layout-left-navbar-width", "0px");

    document.body.classList.add("layout-left-navbar--hover");

    setTimeout(() => leftNavbar.classList.add("active-hover-mode"), 300);
  }

  hoverMode() {
    const _this = this;

    document
      .querySelector(".left-navbar-hover-trigger")
      .addEventListener("click", function () {
        document.body.classList.contains("layout-left-navbar--hover")
          ? _this.showNavPanel()
          : _this.hoverNavPanel();
      });
  }

  init() {
    this.initialProcess();
    this.navTrigger();
    this.hoverMode();
  }
}

// const adminNav = new AdminNav();
// adminNav.init();
